import { UserRole, UserType } from '../types';

export const COLORS = {
  bg: 'bg-green-50',
  primary: 'bg-green-800',
  primaryHover: 'hover:bg-green-900',
  textPrimary: 'text-green-900',
  textLight: 'text-green-600',
};

export const MOCK_COMPANIES = [
  { id: '1', name: 'Loja Central' },
  { id: '2', name: 'Oficina Rápida' },
  { id: '3', name: 'Serviços Tomás Melo' },
];

export const MOCK_USERS = [
  {
    id: 'u1',
    name: 'Admin Global',
    email: 'admin@multigestao.pt',
    password: '123',
    role: UserRole.ADMIN,
    companies: ['1', '2', '3']
  },
  {
    id: 'u2',
    name: 'Dono Loja',
    email: 'dono@loja.pt',
    password: '123',
    role: UserRole.OWNER,
    companies: ['1']
  },
  {
    id: 'u3',
    name: 'João Empregado',
    email: 'joao@loja.pt',
    password: '123',
    role: UserRole.EMPLOYEE,
    userType: UserType.COMPLEX,
    companies: ['1']
  }
];

